module.exports = __webpack_public_path__ + "img/checklist-button-ear.2c4704ec.png";